const uuidv4 = require('uuid/v4');

export default class Addtional {
	
	static get TYPE() {
		const TYPE = {
			TEXT: 1,
			NUM: 2,
			ADDRESS: 3,
		};
		return TYPE;
	}

	constructor(params) {
		this.name = params.name;
		this.type = params.type;
		this.min_length = params.min_length;
		this.max_length = params.max_length;
		this.seq = params.seq;
		
		if(params.code !== undefined)
			this.code = params.code;
		else
			this.code = uuidv4();
	}

	get isText() { return this.type === Addtional.TYPE.TEXT }
	get isNumber() { return this.type === Addtional.TYPE.NUM }
	get isAddress() { return this.type === Addtional.TYPE.ADDRESS }

	createAdditionalInfoRules() {
		const rules = [];
		if (this.min_length > 0) {
			const validateRequired = (v) => {
				return !!v || '入力してください'
			};
			rules.push(validateRequired);
			const validateMinLength = (v) => {
				return v.length >= this.min_length || this.min_length + '文字以上入力してください'
			};
			rules.push(validateMinLength);
		}
		const validateMaxLength = (v) => {
			return v.length <= this.max_length || this.max_length + '文字以内で入力してください'
		};
		rules.push(validateMaxLength);
		
		if (this.isNumber) {
			const validateNumber = (v) => {
				return (v === null || v.length == 0 || /^[0-9]+$/.test(v)) || '数値を入力してください'
			};
			rules.push(validateNumber);
		}
		
		return rules;
	}
	
	createAdditionalInfoFilteringRules() {
		const rules = [];
		const validateMaxLength = (v) => {
			return v.length <= this.max_length || this.max_length + '文字以内で入力してください'
		};
		rules.push(validateMaxLength);
		
		if (this.isNumber) {
			const validateNumber = (v) => {
				return (v === null || v.length == 0 || /^[0-9]+$/.test(v)) || '数値を入力してください'
			};
			rules.push(validateNumber);
		}
		
		return rules;
	}

	asHash() {
		return {
			code: this.code,
			name: this.name,
			type: this.type,
			min_length: this.min_length,
			max_length: this.max_length,
			seq: this.seq,
		};
	}
}
